export default __webpack_public_path__ + "static/media/15-1.084a70f7.mp3";